export const routes = {
  root: "/",
  register: "/register",
  login: "/login",
  dictionary: "/dictionary",
  recommend: "/recommend",
  training: "/training",
} as const;
